import type { Locale } from './i18n-config'

// Client-side dictionary loader (no server-only import)
const dictionaries = {
  en: () => import('./dictionaries/en.json').then((module) => module.default),
  ua: () => import('./dictionaries/ua.json').then((module) => module.default)
}

export const getDictionaryClient = async (locale: Locale) =>
  dictionaries[locale]?.() ?? dictionaries.en()